const FieldProgrami = ({ label, programi }) => {
  return (
    <div className="form-group">
      <span className="field-label">{label}: </span>
      <div className="mx-2 my-1">
        {programi && programi.length > 0 && (
          <ul>
            {programi.map((program, index) => (
              <li key={index}>{program}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FieldProgrami;
